const currentYear = new Date().getFullYear().toString()

export const initialValues = {
  year: { label: currentYear, value: currentYear },
  months: [],
  companies: [],
  stations: [],
  rfc: "",
}
  
export const fieldValidations = {
  stations: {
    required: true
  },
  unitType: {
    required: true
  }
}